import { ActionTree } from 'vuex';
import { RootState } from '@/ui/store/types/root-module.types';
import serviceProvider from '@/services/service-provider';
import { iProfile } from '@/entities/profile/profile.types';
import { FeedState } from '../../types/feed-module.types';
import { PROFILE_MUTATIONS } from './mutations';

export const actions: ActionTree<FeedState, RootState> = {
  clear({ commit }) {
    commit(PROFILE_MUTATIONS.SET_REVIEWS, []);
    commit(PROFILE_MUTATIONS.SET_PROFILE, null);
  },
  async loadReviews({ commit }, userId: string) {
    try {
      const reviews = await serviceProvider.review.getReviewsByUser(userId, null);
      commit(PROFILE_MUTATIONS.SET_REVIEWS, reviews);
    } catch (error) {
      console.log(error);

      commit(PROFILE_MUTATIONS.SET_REVIEWS, []);
    }
  },
  async loadMore({ commit, state }, userId: string) {
    try {
      const last = state.reviews.length ? state.reviews[state.reviews.length - 1] : null;
      const reviews = await serviceProvider.review.getReviewsByUser(userId, last);
      commit(PROFILE_MUTATIONS.APPEND_REVIEWS, reviews);
    } catch (error) {
      commit(PROFILE_MUTATIONS.SET_REVIEWS, []);
    }
  },
  async loadUser({ commit }, userIdOrSlug: string) {
    try {
      const profile = await serviceProvider.profile.findByIdOrSlug(userIdOrSlug);
      commit(PROFILE_MUTATIONS.SET_PROFILE, profile);
    } catch (error) {
      commit(PROFILE_MUTATIONS.SET_PROFILE, null);
    }
  },
  updateProfileAttribtues({ commit }, profile: Partial<iProfile>) {
    commit(PROFILE_MUTATIONS.UPDATE_PROFILE_ATTRIBUTES, profile);
  },
};
